(function () {
  'use strict';
  if (window.BFCalendarConfetti) return;
  var active = new WeakMap();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var gold = ['#fff1c4','#ffe39a','#f6d36a','#f0b429','#dca42e','#c9842a','#fff8e0'];
  function stop(layer) {
    if (!layer) return;
    var state = active.get(layer);
    if (state) { cancelAnimationFrame(state.frame); if (state.fire) state.fire.reset(); active.delete(layer); }
    layer.replaceChildren();
    layer.hidden = true;
  }
  function start(layer) {
    stop(layer);
    if (!layer || reduced.matches || !window.confetti) return;
    layer.hidden = false;
    var state = { frame: 0, fire: null };
    active.set(layer,state);
    state.frame = requestAnimationFrame(function () {
      if (active.get(layer)!==state || !layer.isConnected || !layer.closest('dialog[open]')) { stop(layer); return; }
      var dialog=layer.closest('dialog');
      if (!dialog.matches(':modal')) {
        var card=dialog.querySelector('.bf-prize__card').getBoundingClientRect();
        if (card.bottom>window.innerHeight-16) window.scrollBy({top:card.bottom-window.innerHeight+16,behavior:'auto'});
        else if (card.top<80) window.scrollBy({top:card.top-80,behavior:'auto'});
      }
      var canvas=document.createElement('canvas');canvas.setAttribute('aria-hidden','true');layer.appendChild(canvas);
      state.fire=window.confetti.create(canvas,{resize:true,useWorker:false,disableForReducedMotion:true});
      var defaults={origin:{x:.5,y:.7},colors:gold};
      var last;
      function fire(ratio,options) { last=state.fire(Object.assign({},defaults,options,{particleCount:Math.floor(200*ratio)})); }
      // Official Realistic Look demo: five bursts, changed to gold colors only.
      fire(.25,{spread:26,startVelocity:55});
      fire(.2,{spread:60});
      fire(.35,{spread:100,decay:.91,scalar:.8});
      fire(.1,{spread:120,startVelocity:25,decay:.92,scalar:1.2});
      fire(.1,{spread:120,startVelocity:45});
      Promise.resolve(last).then(function () { if(active.get(layer)===state)stop(layer); });
    });
  }
  window.BFCalendarConfetti={start:start,stop:stop};
  document.addEventListener('close',function(event){if(event.target.tagName==='DIALOG')event.target.querySelectorAll('[data-bf-confetti]').forEach(stop);},true);
  document.addEventListener('keydown',function(event){
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-bf-pc-calendar] dialog.is-prize[open]').forEach(function(dialog){if(!dialog.matches(':modal'))dialog.close();});
  });
  document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-bf-confetti]').forEach(stop);});
  function onReducedChange(){if(reduced.matches)document.querySelectorAll('[data-bf-confetti]').forEach(stop);}
  if(reduced.addEventListener)reduced.addEventListener('change',onReducedChange);
  else if(reduced.addListener)reduced.addListener(onReducedChange);
})();
